export enum DocumentScope {
	EMPLOYEE = 'EMPLOYEE',
	COMPANY = 'COMPANY',
}
